(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    const root=document.documentElement;
const body=document.body;
const toggleClass=(selector,className,force)=>{const target=document.querySelector(selector);if(target)target.classList.toggle(className,force)};
document.addEventListener('click',event=>{
  const button=event.target.closest('[data-action]');
  if(!button)return;
  const action=button.dataset.action;
  if(action==='toggle-search')toggleClass('#SearchPanel','is-open');
  if(action==='open-menu'){toggleClass('#MobileNav','is-open',true);body.classList.add('drawer-open')}
  if(action==='close-menu'){toggleClass('#MobileNav','is-open',false);body.classList.remove('drawer-open')}
  if(action==='open-cart'){toggleClass('#CartDrawer','is-open',true);body.classList.add('drawer-open')}
  if(action==='close-cart'){toggleClass('#CartDrawer','is-open',false);body.classList.remove('drawer-open')}
});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){toggleClass('#MobileNav','is-open',false);toggleClass('#CartDrawer','is-open',false);body.classList.remove('drawer-open')}});
document.addEventListener('submit',async event=>{
  const form=event.target.closest('[data-ajax-cart-form]');
  if(!form)return;
  event.preventDefault();
  const submit=form.querySelector('[type="submit"]');
  if(submit)submit.disabled=true;
  try{
    const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
    if(!response.ok)throw new Error('cart');
    window.location.href=window.Shopify.routes.root+'cart';
  }catch(error){form.submit()}
});
document.querySelectorAll('[data-variant-select]').forEach(select=>{
  select.addEventListener('change',()=>{
    const option=select.options[select.selectedIndex];
    const form=select.closest('form');
    const button=form&&form.querySelector('[type="submit"]');
    const price=document.querySelector('[data-product-price]');
    if(button){button.disabled=option.dataset.available!=='true';button.textContent=option.dataset.available==='true'?button.dataset.addText:button.dataset.soldText}
    if(price&&option.dataset.price)price.textContent=option.dataset.price;
    const url=new URL(window.location.href);url.searchParams.set('variant',select.value);window.history.replaceState({},'',url);
  });
});
root.classList.add('js');
  } catch(e) { console.error(e); }
})();

})();
